import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { STATUS_NEW_ADDRESS_ADDED } from '../../../constants/sessionStorage';
import { storeInSessionStorage } from '../../../util/helpers/sessionStorageHelper';
import BasicModal from '../../BasicModal/BasicModal';
import AddDeliveryAddress from './AddDeliveryAddress';
import { CustomToast } from '../../CustomToast/CustomToast';

const AddDeliveryAddressModal = ({
  isOpen,
  onClose,
  title,
  isAddingCCFlow,
  page,
  setSuccessToast,
  bankName,
  onAddressAdded,
  editAddress,
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState('');
  const errorRef = useRef('');

  const handleSetError = (errorMessage) => {
    errorRef.current = errorMessage;
    setError(errorMessage);
  };

  const handleNext = (newAddress, submittedAddress) => {
    if (!errorRef.current && page === 'address') {
      toast.custom(() => (
        <CustomToast
          title={t('buyWizard.common.addressAdded')}
          message={t('buyWizard.common.addressAddedSuccessfully')}
        />
      ));
    }
    if (!errorRef.current && page === 'buy') {
      setSuccessToast({
        isOpen: true,
        title: t('buyWizard.newAddressAdded'),
        message: t('buyWizard.newAddressAddedMessage'),
      });
    }
    if (!errorRef.current && onAddressAdded) {
      onAddressAdded(newAddress, submittedAddress);
    }
    if (!errorRef.current) {
      if (page === 'buy' || page === 'address') {
        storeInSessionStorage(STATUS_NEW_ADDRESS_ADDED, true);
      }
      onClose();
    }
  };

  return (
    <BasicModal
      title={title}
      size="sm"
      isOpen={isOpen}
      close={onClose}
      closeIconVisible
    >
      <AddDeliveryAddress
        onButtonClick={onClose}
        handleNext={handleNext}
        setError={handleSetError}
        error={error}
        isAddingCCFlow={isAddingCCFlow}
        bankName={bankName}
        editAddress={editAddress}
      />
    </BasicModal>
  );
};

AddDeliveryAddressModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  isAddingCCFlow: PropTypes.bool,
  page: PropTypes.string,
  setSuccessToast: PropTypes.func,
  bankName: PropTypes.string,
  onAddressAdded: PropTypes.func,
  editAddress: PropTypes.shape({
    AddressUid: PropTypes.string,
    AddressLine: PropTypes.string,
    AddressLine2: PropTypes.string,
    City: PropTypes.string,
    StateRegion: PropTypes.string,
    PostalCode: PropTypes.string,
  }),
};

export default AddDeliveryAddressModal;
